import { IDatepickerProps } from '../../components/Datepicker/types';

export interface IDatepickerHOCProps extends IDatepickerProps {
}

export enum EButtonType {
    DATE = 'date',
    TIME = 'time'
}
